import { NodeType } from '@amirada/lib-shared'
import type * as tp from '@base/utils/types'
import type { BreadcrumbItem } from '#ui/types'
import { useAppIndexStore } from '@base/stores/indexStore'
import { usePathStore } from '@base/stores/pathStore'
import { ut_returnNewRoute } from '@base/utils/utils'

export function useBreadCrumb() {
  const indexStore = useAppIndexStore()
  const pathStore = usePathStore()

  // Get breadcrumb data
  const breadCrumbData = computed((): BreadcrumbItem [] => {
    const allBreadcrumbs: tp.IBreadCrumbItem[] | undefined = pathStore.getPathData(indexStore.state.paramData)
    if (!allBreadcrumbs) { return [] }
    // console.log('compute breadCrumbData', allBreadcrumbs);
    const visibleBreadcumbs: tp.IBreadCrumbItem[] = []
    const embeddedInfo: tp.IParamEmbedInfo = indexStore.state.paramData.embeddedInfo || {}

    // CMS breadcrumb items if embedded
    if (embeddedInfo.protocol && embeddedInfo.hostname && embeddedInfo.basebc && embeddedInfo.basepath) {
      const splitBreadCrumb = embeddedInfo.basebc.split('/')
      const splitPath = (embeddedInfo.hostname + embeddedInfo.basepath).split('/')
      const startIndex: number = splitPath.length - splitBreadCrumb.length
      let absPath = splitPath.slice(0, (splitPath.length - splitBreadCrumb.length) + 1).join('/')
      for (const [index, part] of splitBreadCrumb.entries()) {
        if (part) {
          absPath += '/' + splitPath[startIndex + index]
          const item: tp.IBreadCrumbItem = {
            meta: {},
            nodeID: -1,
            attrs: {},
            cod: '',
            mediaName: '',
            nodeType: NodeType.nt_None,
            namePath: '',
            slugPath: '',
            nodeName: part,
            desc: part,
            abspath: embeddedInfo.protocol + absPath,
          }
          visibleBreadcumbs.push(item)
        }
      }
    }

    // invisible fix path (hidstartpath) remove
    let startIndex: number = 0
    if (embeddedInfo.hidstartpath) {
      const splitRoot = embeddedInfo.hidstartpath.split('/')
      startIndex = embeddedInfo.basebc ? splitRoot.length : splitRoot.length - 1
    }

    // Combine breadcrumbs
    for (let i = startIndex; i < allBreadcrumbs.length; i++) {
      visibleBreadcumbs.push(allBreadcrumbs[i] as tp.IBreadCrumbItem)
    }

    // Modify for UI
    const result: BreadcrumbItem[] = []
    for (const item of visibleBreadcumbs) {
      result.push ({
        label: item.desc,
        to: item.abspath ? item.abspath : linkPath(item.slugPath),
      })
    }
    return result
  })

  // Get path
  function linkPath(path: string): tp.IParamRouter {
    const indexStore = useAppIndexStore()
    const queryAddType: tp.IQueryAddType = {
      noPageParams: true,
      noGlobalParams: false,
      noPsx: true,
      noHash: true,
      noCustom: true,
      noTab: true,
    }
    return ut_returnNewRoute(indexStore.getCountryLangPath + '/' + path, {}, '', queryAddType)
  }

  function deleteScrollPos(): void {
    indexStore.deleteScrollPos()
  }

  return {
    indexStore,
    breadCrumbData,
    deleteScrollPos,
  }
}
